<template>
  <div id="app">
    <el-container v-if="showLayout" class="layout">
      <el-header class="layout-header">
        <app-header />
      </el-header>

      <el-container class="layout-body">
        <app-sidebar />

        <el-main class="layout-main">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
    <div v-else class="login-layout">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppSidebar from "./components/AppSidebar.vue";

export default {
  components: {
    AppHeader,
    AppSidebar
  },
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: []
    };
  },
  computed: {
    showLayout() {
      return this.$route.path !== "/login";
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style>
.layout {
  min-height: 100vh;
  background: #f5f6f9;
}

.layout-header {
  padding: 0 28px;
  background: #101826;
  color: #fff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.18);
}

.login-layout {
  min-height: 100vh;
  background: #f5f6f9;
}

.layout-body {
  height: calc(100vh - 60px);
}

.layout-main {
  padding: 24px 28px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.page-subtitle {
  color: #6b7280;
  margin-top: 4px;
  font-size: 13px;
}

.stats-row {
  margin-bottom: 18px;
}

.stat-label {
  color: #6b7280;
  font-size: 12px;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  margin: 8px 0;
}

.stat-meta {
  color: #10b981;
  font-size: 12px;
}

.list-card .el-card__header {
  padding: 12px 20px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-table th {
  background: #f9fafb;
}
</style>
